import styled from 'styled-components';

export const SurveyReportWrapper: any = styled.div`

.surveyReportScreen{
    margin: 0px 40px;
    padding-top: 50px;
}

.surveyReportScreen .pageContent{
    padding-top: 100px;
}

.surveyReportScreen .invalidReport{
    margin: 0 auto;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
}

.surveyReportScreen #centeringContainer #viz-client-container{
    margin: 0 auto;
}
.surveyReportScreen .iframeSurveyReport{
    margin: 0 auto;
    margin-top: 20px;
    width: 50%;
    margin-left: 25%;
}


.pageTitleSection {
    left: -30px;
}
.media-list-wrapper .media-list:first-child {
    border-bottom: 0px;
}
.media-list-wrapper .media-list .media-content {
    cursor: pointer;
}
.media-list-wrapper .media-list .media-body h5{
    font-size: 18px;
}
.media-webinar-heading{
    padding: 0px 2%;
    display: flex;
}
.media-webinar-heading .alignLeft p{
    font-size: 18px;
}

`


// WEBPACK FOOTER //
// ./src/styles/surveyreport.tsx